// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wqWQw","title":"styles_title__3ecYz"};